/*
  Zekerheidspakket aan/uit in de winkelwagen. Hoort bij snippets/cart-zekerheidspakket.liquid.

  Gaat via /cart/update.js met een absolute hoeveelheid (1 of 0) in plaats van
  /cart/add.js, zodat herhaald klikken het pakket nooit dubbel in de wagen zet.

  De klikafhandeling staat op document, want het blok zit in de HTML die de
  drawer en de cart-pagina bij elke update opnieuw inladen; listeners op het
  blok zelf zouden die vervanging niet overleven.
*/
(function () {
  'use strict';

  if (window.zekerheidspakketLoaded) return;
  window.zekerheidspakketLoaded = true;

  function sectionsFor(scope) {
    if (!scope || typeof scope.getSectionsToRender !== 'function') return [];
    return scope.getSectionsToRender();
  }

  function render(state, sections) {
    sections.forEach(function (section) {
      var host = document.getElementById(section.section);
      if (!host || !state.sections || !state.sections[section.id]) return;

      var target = host.querySelector(section.selector) || host;
      var source = new DOMParser()
        .parseFromString(state.sections[section.id], 'text/html')
        .querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });

    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);
    var page = document.getElementById('main-cart');
    if (page) page.classList.toggle('is-empty', state.item_count === 0);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-zeker-toggle]');
    if (!button) return;

    event.preventDefault();

    var block = button.closest('.zeker-block');
    if (block.classList.contains('is-loading')) return;
    block.classList.add('is-loading');

    var isOn = button.getAttribute('aria-checked') === 'true';
    var scope = button.closest('cart-drawer-items') || button.closest('cart-items') ||
      (button.closest('cart-drawer') && document.querySelector('cart-drawer-items'));
    var sections = sectionsFor(scope);

    var updates = {};
    updates[button.dataset.zekerVariant] = isOn ? 0 : 1;

    fetch(window.routes.cart_update_url, Object.assign({}, fetchConfig(), {
      body: JSON.stringify({
        updates: updates,
        sections: sections.map(function (section) { return section.id; }),
        sections_url: window.location.pathname
      })
    }))
      .then(function (response) { return response.json(); })
      .then(function (state) {
        render(state, sections);
        if (scope && typeof scope.updateProductRecommendation === 'function') {
          scope.updateProductRecommendation();
        }
      })
      .catch(function () {
        block.classList.remove('is-loading');
      });
  });
})();
